

export const setGlobalError = (state, payload) => {
    state.globalError = payload.value
}

export const logout = (state) => {
    state.globalError = ''

    state.auth.app_user.user = null;
    state.auth.app_user.authenticated = false;
    state.auth.app_user.access_token = null;
    state.auth.app_user.longitude = null;
    state.auth.app_user.latitude = null;
    state.auth.app_user.is_at_drive_trough = false;
    state.auth.app_user.temp_user = null;

    state.auth.web_user.authenticated = false;
    state.auth.web_user.user = null;
    state.auth.web_user.account = null;

    state.auth.reward_data = [];
}

